<div id="post-form-container">
    <h1>{{title}}</h1>
    <form [formGroup]="postForm">
            <div class="choose-group">
                <select formControlName="group_id" (change)="selectGroup($event)">
                    <option value="" selected disabled>{{defaultSelect}}</option>
                    <option *ngFor="let group of groupsStore.groups"
                            [value]="group.id">{{group.name}}</option>
                </select>
            </div>

        <div class="form-controls">
            <ckeditor id="editor" [editor]="Editor"
                      [config]="{removePlugins : [['format', 'flashupload']]}"
                      [formControlName]="'description'"
                      (change)="chengCKEditor($event)"
                      (ready)="onReady($event)">
            </ckeditor>
            <!--            <textarea formControlName="description" placeholder="Create a public post..."></textarea>-->

            <div class="action-btn-wrap">
                <button (click)="savePosts()" id="add-post">{{edit ? 'Edit' : 'Post'}}</button>
            </div>
        </div>
    </form>
</div>
